import { getLocale } from "../runtime";

const da_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Leveres inden for 1-2 hverdage`
};

const en_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Delivered in 1-2 business days`
};

const es_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Entrega en 1-2 días laborables`
};

const fi_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Toimitus 1-2 arkipäivässä`
};

const nb_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Leveres om 1-2 arbeidsdager`
};

const sv_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Levereras om 1-2 arbetsdagar`
};

const delivery = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_delivery(inputs)
	if (locale === "en") return en_delivery(inputs)
	if (locale === "es") return es_delivery(inputs)
	if (locale === "fi") return fi_delivery(inputs)
	if (locale === "nb") return nb_delivery(inputs)
	if (locale === "sv") return sv_delivery(inputs)
	return "delivery";
};

export { delivery as "delivery" };